module.exports = __webpack_public_path__ + "static/media/estate.8c67202b.jpg";